// Login action types
export const GENESIS_SETUP_REQUEST = 'genesis_setup_request';
export const GENESIS_SETUP_SUCCESS = 'genesis_setup_success';
export const GENESIS_SETUP_FAILURE = 'genesis_setup_failure';
export const GENESIS_SETUP_RESET = 'genesis_setup_reset';

